module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAAAXNSR0IArs4c6QAAAKxJREFUKBVjNDY2rmBgYIgHYnLAQsb///8zmpqaTgfS6aSYwMjIOPP06dOZTEDG/zNnzmQA6QnEGgBSC9Xznxmm6dmzZzulpaXZgHxbmBg2Gqi5Dai5DCYHNwAkADRkH9CQ30CmM0wBMg3UXA3U3IgshmIASAJoyGGgIR+BTA9khUDNhUDN3chiIDaGASBBoCEngIa8ADK9QXyg5kyg5qkgNknAxMQkDoTxaQIAuBo4X5TTEooAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Dropcaret.png
// module id = 1394
// module chunks = 32